import { useEffect, useState } from "react"
import { Col, Label, OutlineButton, PrimaryButton, ReactSelectBox, Row } from "client/CommonComponents"
import { useDispatch, useSelector } from "react-redux"
import { DatePicker } from "rsuite"
import userProfileSelectors from 'redux/UserProfile/selectors'
import './OOOTab.scss'
import { useDebounce } from "client/CommonComponents/CustomDebounce/DebounceHook"
import { getApproversList, getCurrentSettingsProfile, getValidateBackUpApprover, saveOutOfOfficeSettingProfile, setApproversList, setCurrentSettingsProfile, setIsOutOfOfficeSavedProfile, setValidateBackUpApprover } from "Store/OrderManagement/OutOfOffice/OutOfOfficeActions"
import moment from "moment"
import ConfirmationBee from '../../../assets/images/Confirmation Bee.svg'
import { convertToUserTimezone, popupInitialData } from "utils"
import CancelConfirmationPopup from "client/CommonComponents/DialogBox/CancelConfirmationPopup"


const valuesFields = new Map([
    ['backupApprover', "Backup Approver"],
    ['startDate', "Start date"],
    ['endDate', "End date"],
])


const OOOTabContent = (props: any) => {

    const { closeModalPopup } = props

    const dispatch = useDispatch()

    const {
        approversList,
        userData,
        currentOOOSettingsProfile,
        isOutOfOfficeSavedProfile,
        validateBackupApprover
    }: any = useSelector((state: any) => ({
        approversList: state?.OutOfOfficeReducer?.approversList,
        currentOOOSettingsProfile: state?.OutOfOfficeReducer?.currentOOOSettingsProfile,
        userData: userProfileSelectors.getUserDetails(state),
        isOutOfOfficeSavedProfile: state?.OutOfOfficeReducer?.isOutOfOfficeSavedProfile,
        validateBackupApprover: state?.OutOfOfficeReducer?.validateBackupApprover
    }))

    const [values, setValues] = useState<any>({
        backupApprover: '',
        startDate: null,
        endDate: null
    })

    const [errors, setErrors] = useState<any>({})
    const [secondaryApproverText, setSecondaryApproverText] = useState<string>("")
    const [approverList, setAproverList] = useState<any>([])
    const [isCurrentSettingExist, setIsCurrentSettingExist] = useState<boolean>(false)
    const [currentSettingFromDate, setCurrentSettingFromDate] = useState<any>(null)
    const [popupContent, setPopupContent] = useState<any>(popupInitialData);
    const [clickType, setClickType] = useState<any>(null);

    const debouncedSecondaryApproverText = useDebounce(secondaryApproverText, 500)

    useEffect(() => {
        dispatch(setApproversList([]))
        dispatch(getCurrentSettingsProfile(userData?.emailId))
    }, [])

    useEffect(() => {
        if (debouncedSecondaryApproverText?.length > 2) {
            dispatch(getApproversList({
                emailId: debouncedSecondaryApproverText,
                isPrimaryApprover: false
            }))
        }
    }, [debouncedSecondaryApproverText])

    useEffect(() => {
        const options = approversList?.response?.reduce((acc: any, cur: any) => (cur?.value !== userData?.emailId ? [...acc, {...cur, label: cur?.text}] : acc), []);
        setAproverList(options)
        if (currentOOOSettingsProfile?.backupApproverEmail) {
            let backupApprover = approversList?.response?.find((approver: any) => approver?.value === currentOOOSettingsProfile?.backupApproverEmail)
            setValues({
                ...values,
                backupApprover: values?.skipApprover ? "" : { ...backupApprover, label: backupApprover?.text }
            })
        }
    }, [approversList])

    useEffect(() => {
        if (currentOOOSettingsProfile?.outOfOfficeSettingId) {
            setIsCurrentSettingExist(true)
            setCurrentSettingFromDate(new Date(convertToUserTimezone(currentOOOSettingsProfile?.fromDate)))
            if (currentOOOSettingsProfile?.backupApproverEmail) {
                dispatch(getApproversList({
                    emailId: currentOOOSettingsProfile.backupApproverEmail?.split('.')[0],
                    isPrimaryApprover: false
                }))
            }
            setValues({
                ...values,
                startDate: new Date(convertToUserTimezone(currentOOOSettingsProfile?.fromDate)),
                endDate: new Date(convertToUserTimezone(currentOOOSettingsProfile?.toDate)),
                outOfOfficeSettingId: currentOOOSettingsProfile?.outOfOfficeSettingId
            })
            setErrors((prev: any) => ({ ...prev, startDate: "", endDate: "", backupApprover: "" }))
        }else{
            setCurrentSettingFromDate(null)
            setIsCurrentSettingExist(false)
            setValues({
                ...values,
                startDate: null,
                endDate: null,
                backupApprover : ''
            })
        }

    }, [currentOOOSettingsProfile])

    useEffect(() => {
        if (typeof isOutOfOfficeSavedProfile === 'boolean') {
            setIsCurrentSettingExist(false)
            if (clickType == 'clear') {
                setValues({
                    ...values,
                    backupApprover: '',
                    startDate: null,
                    endDate: null
                })
                setErrors({})
            } else {
                if (!isOutOfOfficeSavedProfile) {
                    setTimeout(() => {
                        dispatch(setIsOutOfOfficeSavedProfile(undefined))
                    }, 3000)
                }
            }
            setClickType(null)
        }

    }, [isOutOfOfficeSavedProfile])

    useEffect(() =>{
        if(validateBackupApprover != null && validateBackupApprover?.page == 'OOO'){
            if(validateBackupApprover?.response?.isValid){
                commonSaveFunction('save')
            } else if(validateBackupApprover?.response?.errorMessage?.length > 0) {
                setPopupContent({
                    ...popupContent,
                    title: "INFORMATION",
                    subtextcontent: validateBackupApprover?.response?.errorMessage,
                    isDialogVisible: true,
                    outlineBtnText: "Ok",
                    isSingleConfirmationBtn: true,
                    titleImg: ConfirmationBee,
                    popupOutlinebtnOnclick: () => {
                        hideDialog();
                    },
                    hideDialog: () => hideDialog()
                })
            }else{
                setPopupContent({
                    ...popupContent,
                    title: "INFORMATION",
                    subtextcontent: "Error occured while validating the approver.",
                    isDialogVisible: true,
                    outlineBtnText: "Ok",
                    isSingleConfirmationBtn: true,
                    titleImg: ConfirmationBee,
                    popupOutlinebtnOnclick: () => {
                        hideDialog();
                    },
                    hideDialog: () => hideDialog()
                })
            }
            dispatch(setValidateBackUpApprover(null))
        }
    },[validateBackupApprover])

    const validate = (name: string, value: any) => {
        let isValid = true
        if (!value) {
            setErrors((prev: any) => ({ ...prev, [name]: `Please select ${valuesFields?.get(name)}` }))
            isValid = false
        } else if (name === 'startDate' && value && values?.endDate && moment(values?.endDate).isBefore(value)) {
            setErrors((prev: any) => ({ ...prev, [name]: `${valuesFields?.get(name)} cannot be after ${valuesFields?.get('endDate')}` }))
            isValid = false
        } else if (name === 'endDate' && value && values?.startDate && moment(value)?.isBefore(values.startDate)) {
            setErrors((prev: any) => ({ ...prev, [name]: `${valuesFields?.get(name)} cannot be before ${valuesFields?.get('startDate')}` }))
            isValid = false
        } else {
            setErrors((prev: any) => ({ ...prev, [name]: '' }))
        }
        return isValid
    }

    const validateValues = () => {
        let isValid: boolean[] = []
        for (const value in values) {
            if (value == 'backupApprover') {
                isValid.push(validate(value, values[value]?.value))
            } else {
                isValid.push(validate(value, values[value]))
            }
        }
        return isValid.every((val: boolean) => val)
    }

    const handleChange = (value: any, name: string) => {
        setValues((prev: any) => ({ ...prev, [name]: value }))
        validate(name, value?.value)
    }

    const handleDateChange = (date: any, name: string) => {
        setValues((prev: any) => ({ ...prev, [name]: date }))
        validate(name, date)
    }

    const hideDialog = () => {setPopupContent(popupInitialData); dispatch(setIsOutOfOfficeSavedProfile(undefined))}

    const commonSaveFunction = (clickType?: any) => {
        setClickType(clickType)
        dispatch(setIsOutOfOfficeSavedProfile(undefined))
        let isValidToSubmit = validateValues()
        if (isValidToSubmit || clickType == 'clear') {
            const payload = {
                outOfOfficeSettingId: values?.outOfOfficeSettingId ?? 0,
                primaryApproverEmail: userData?.emailId,
                backupApproverEmail: clickType == 'save' ? values?.backupApprover?.value : '',
                fromDate: clickType == 'save' ? moment(values?.startDate).utc().format("YYYY-MM-DDTHH:mm:ss") : moment(currentSettingFromDate).utc().format("YYYY-MM-DDTHH:mm:ss"),
                toDate: clickType == 'save' ? moment(values?.endDate).utc().format("YYYY-MM-DDTHH:mm:ss") : moment().utc().format("YYYY-MM-DDTHH:mm:ss"),
                isSkipApproval: false,
                savedBy: userData?.emailId,
                isSuperAdminOverride: false
            }
            dispatch(saveOutOfOfficeSettingProfile(payload))
        }
    }

    const handleSaveClick = (e?: any, clickType?: any) => {
        if(clickType == 'clear'){
            setPopupContent({
                ...popupContent,
                title: "CONFIRMATION",
                subtextcontent: "Are you sure you want to clear the approver settings?",
                isDialogVisible: true,
                outlineBtnText: "No",
                primaryBtnText: "Yes",
                isSingleConfirmationBtn: false,
                titleImg: ConfirmationBee,
                popupOutlinebtnOnclick: () => {
                    hideDialog();
                },
                popupPrimarybtnOnclick : () => {
                    commonSaveFunction('clear')
                    hideDialog()
                },
                hideDialog: () => hideDialog()
            })
        } else {
            let isValidToSubmit = validateValues()
            if(isValidToSubmit){
            dispatch(getValidateBackUpApprover({
                backupApproverEmail: values?.backupApprover?.value,
                fromDate: moment(values?.startDate).utc().format("YYYY-MM-DDTHH:mm:ss"),
                toDate: moment(values?.endDate).utc().format("YYYY-MM-DDTHH:mm:ss"),
            },"OOO"))
        }
        }
    }

    const handleCancelClick = () => {
        setErrors({})
        setValues({})
        setCurrentSettingsProfile({})
        setIsOutOfOfficeSavedProfile(undefined)
        closeModalPopup()
    }

    const searchApprover = (value: any, action: any, name: string) => {
        if (action.action === "input-change") {
            setSecondaryApproverText(value)
        }
    };



    return (
        <>
        <div className="ooo-profile">
            <div className='mb-3 clearfix'>
                <p className='pull-left blueLabel mt-2'>OUT OF OFFICE</p>
            </div>
            <Row className="mt-2 oof-override">
                <Col xs={12} sm={12} md={4} lg={4} className={'mb-3'}>
                    <Label required data-attribute="OOOTab_container_Default_Label">Start Date</Label>
                    <DatePicker
                        name="startDate"
                        placeholder="Select Date and Time"
                        format="MM/dd/yyyy HH:mm"
                        value={values?.startDate}
                        onChange={(date: any) => handleDateChange(date, "startDate")}
                        className={errors?.startDate ? 'controlValidation' : ''}
                        shouldDisableDate={date => moment(date).isBefore(new Date(), 'day')}
                    />
                    {errors?.startDate ? <p className='validMessage'>{errors?.startDate}</p> : ""}
                </Col>
                <Col xs={12} sm={12} md={4} lg={4} className={'mb-3'}>
                    <Label required data-attribute="OOOTab_container_Default_Label_2">End Date</Label>
                    <DatePicker
                        name="endDate"
                        placeholder="Select Date and Time"
                        format="MM/dd/yyyy HH:mm"
                        value={values?.endDate}
                        onChange={(date: any) => handleDateChange(date, "endDate")}
                        className={errors?.endDate ? 'controlValidation' : ''}
                        shouldDisableDate={date => moment(date).isBefore(new Date(), 'day')}
                    />
                    {errors?.endDate ? <p className='validMessage'>{errors?.endDate}</p> : ""}
                </Col>
                <Col xs={12} sm={12} md={4} lg={4} className={'mb-3'}>
                    <Label required data-attribute="OOOTab_container_Default_Label_3">Backup Approver</Label>
                    <ReactSelectBox
                        name="backupApprover"
                        placeholder="Search Backup Approver"
                        options={approverList}
                        onChange={(value: any) => handleChange(value, "backupApprover")}
                        value={values?.backupApprover}
                        isSearchable={true}
                        onInputChange={(value: any, action: any) => searchApprover(value, action, 'backupApprover')}
                        className={errors?.backupApprover ? 'controlValidation' : ''}
                        isDisabled={values?.skipApprover}
                     data-attribute="OOOTab_container_backupApprover_SearchSelectBox" />
                    {errors?.backupApprover ? <p className='validMessage'>{errors?.backupApprover}</p> : ""}
                </Col>
            </Row>
            <div className="btn-block-oof">
                {typeof isOutOfOfficeSavedProfile === 'boolean' && !isOutOfOfficeSavedProfile ? <p className='validMessage mx-2'>Error Saving Out of office, Please try again</p> : ""}
                <PrimaryButton 
                    text="Reset" 
                    className={'me-2'}
                    onClick={(e?: any) => handleSaveClick(e, 'clear')}
                    disabled={((values?.backupApprover || values.skipApprover) && isCurrentSettingExist) ? false : true}
                 data-attribute="OOOTab_container_Default_Button" />
                <OutlineButton
                    text="Cancel"
                    className={'me-2'}
                    onClick={handleCancelClick}
                 data-attribute="OOOTab_container_Default_Button_2" />
                <PrimaryButton
                    text="Save"
                    className={'me-0'}
                    onClick={(e?: any) => handleSaveClick(e, 'save')}
                 data-attribute="OOOTab_container_Default_Button_3" />
            </div>
        </div>
        {popupContent.isDialogVisible ? <CancelConfirmationPopup
              hideDialog={!popupContent.isDialogVisible}
              onDismiss={popupContent.hideDialog}
              Popupcontent={popupContent}
              popupOutlinebtnOnclick={() => popupContent.popupOutlinebtnOnclick()}
              popupPrimarybtnOnclick={() => popupContent.popupPrimarybtnOnclick()}
            /> : ""}
        </>
    )
}

export default OOOTabContent